import { render } from "./SwapContactCard.vue?vue&type=template&id=019811c8&scoped=true"
import script from "./SwapContactCard.vue?vue&type=script&lang=js"
export * from "./SwapContactCard.vue?vue&type=script&lang=js"

import "./SwapContactCard.vue?vue&type=style&index=0&id=019811c8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019811c8"]])

export default __exports__